<template>
  <div
    class="key-data-container"
    role="group"
    :aria-labelledby="labelId"
    :aria-describedby="describedByIds"
  >
    <k-panel :has-content-toggle="false">
      <template #header>
        <div :id="labelId" class="key-stat-label uppercase text-wide">
          <slot name="label">{{ label }}</slot>
        </div>
      </template>
      <template #body>
        <p
          v-if="description || $slots.description"
          :id="descriptionId"
          class="text-secondary"
        >
          <slot name="description">{{ description }}</slot>
        </p>
        <span class="stat-value" :class="{ warning: hasWarning }">
          <span class="sr-only">{{ screenReaderText }}</span>
          <span aria-hidden="true">
            <b>{{ value }}</b><span v-if="suffix">{{ suffix }}</span>
          </span>
        </span>
        <p
          v-if="hasWarning"
          :id="warningId"
          class="warning-message text-warning"
          role="status"
        >
          <slot name="warning">{{ warningMessage }}</slot>
        </p>
      </template>
    </k-panel>
  </div>
</template>

<style scoped>
.key-data-container {
  width: 100%;
  display: flex;
}

.key-stat-label {
  font-size: 0.875rem;
  font-family: hk-grotesk-semibold, monospace;
}

.text-secondary {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--kate-type-secondary);
}

.stat-value b {
  color: var(--kate-neon-primary-text);
  font-size: 2.5rem;
}

.stat-value.warning b {
  color: var(--kate-type-warning);
}

.warning-message {
  margin: 0;
}
</style>

<script>
import KPanel from '@base-components/k-panel.vue';

export default {
  components: {
    KPanel,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    screenReaderText: {
      type: String,
      required: true,
    },
    suffix: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    hasWarning: {
      type: Boolean,
      default: false,
    },
    warningMessage: {
      type: String,
      default: '',
    },
  },

  computed: {
    labelId() {
      return `key-stat-label-${this.$.uid}`;
    },
    descriptionId() {
      return `key-stat-description-${this.$.uid}`;
    },
    warningId() {
      return `key-stat-warning-${this.$.uid}`;
    },
    describedByIds() {
      const ids = [];
      if (this.description || this.$slots.description) {
        ids.push(this.descriptionId);
      }
      if (this.hasWarning) {
        ids.push(this.warningId);
      }
      return ids.length ? ids.join(' ') : undefined;
    },
  },
};
</script>
